import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { ScatterPlot } from "../components/ScatterPlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.scatter_tool_name()}
        toolPath="/scatter-plot"
      />
      <SciHeader title={m.scatter_h1()} intro={m.scatter_intro()} />

      <ScatterPlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.scatter_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.scatter_ex1(), m.scatter_ex2(), m.scatter_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.scatter_faq_q1(), a: m.scatter_faq_a1() },
          { q: m.scatter_faq_q2(), a: m.scatter_faq_a2() },
          { q: m.scatter_faq_q3(), a: m.scatter_faq_a3() },
          { q: m.scatter_faq_q4(), a: m.scatter_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
